module.exports = __webpack_public_path__ + "static/media/Soundscape1-Protected-Area.cb2d569f.WAV";